/* Presentation only: preserve every rail's existing swipe, snap and arrow logic. */
(() => {
  if (!document.body.matches('.ctm-compare-sheets, .ctm-compare-blankets-v2')) return;

  const selector = [
    '.ss-cmp-sheet-comfort-simple__rail', '.ss-cmp-clarity-choice-simple__rail',
    '.ss-cmp-sheet-craft__rail', '.ss-cmp-craft-science',
    '.ss-cmp-sheet-films__rail', '.ss-cmp-blanket-craft__product-grid',
    '.ss-cmp-compare-table-wrap', '.ss-cmp-clarity-index-table-wrap',
    '.ss-cmp-compare-reasons__rail', '.ss-cmp-clarity-index-reasons__rail',
    '.ss-cmp-comparison-shop__rail', '.ss-cmp-clarity-shop__rail',
    '.ss-cmp-quieter-reviews__rail', '.ss-cmp-clarity-shop__colours .ss-cmp-clarity-shop__values'
  ].join(',');
  const rails = new Map();

  function attach(rail) {
    if (rails.has(rail)) return;
    const line = document.createElement('div');
    const thumb = document.createElement('span');
    line.className = 'ss-cmp-polish-scroll-line';
    line.setAttribute('aria-hidden', 'true');
    line.hidden = true;
    line.append(thumb);
    rail.after(line);
    rail.classList.add('ss-cmp-polish-scroll-rail');

    let frame = 0;
    function update() {
      frame = 0;
      const available = rail.scrollWidth - rail.clientWidth;
      const isScrollable = /auto|scroll/.test(getComputedStyle(rail).overflowX);
      line.hidden = !isScrollable || available <= 2 || rail.clientWidth === 0;
      if (line.hidden) return;
      const trackWidth = line.clientWidth;
      const width = Math.min(trackWidth, Math.max(24, trackWidth * rail.clientWidth / rail.scrollWidth));
      // abs also supports RTL scrollLeft, which is negative in modern browsers.
      const position = Math.min(1, Math.max(0, Math.abs(rail.scrollLeft) / available));
      const rtl = getComputedStyle(rail).direction === 'rtl';
      thumb.style.width = `${width}px`;
      thumb.style.transform = `translateX(${(rtl ? 1 - position : position) * (trackWidth - width)}px)`;
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    const observer = new ResizeObserver(schedule);
    observer.observe(rail);
    observer.observe(line);
    Array.from(rail.children).forEach(child => observer.observe(child));
    rail.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    rails.set(rail, () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      rail.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      rail.classList.remove('ss-cmp-polish-scroll-rail');
      line.remove();
    });
    schedule();
  }

  function mount(root) { root.querySelectorAll(selector).forEach(attach); }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rails.forEach((cleanup, rail) => {
      if (!event.target.contains(rail)) return;
      cleanup();
      rails.delete(rail);
    });
  });
})();
